import type { FeatureKey } from './AuthContext';
import { useFabricDisplayStore } from '../stores/useFabricDisplayStore';
import { useFabricTryOnStore } from '../stores/useFabricTryOnStore';
import { useShowcaseStore } from '../stores/useShowcaseStore';
import { useTryOnStore } from '../stores/useTryOnStore';

const WORKSPACE_RESETS: Record<FeatureKey, () => void> = {
  tryon: () => useTryOnStore.getState().reset(),
  'fabric-tryon': () => useFabricTryOnStore.getState().reset(),
  'fabric-display': () => useFabricDisplayStore.getState().reset(),
  'garment-display': () => useShowcaseStore.getState().reset(),
};

export function revokedWorkspaceFeatureKeys(
  previousFeatureKeys: readonly FeatureKey[],
  nextFeatureKeys: readonly FeatureKey[],
): FeatureKey[] {
  const next = new Set(nextFeatureKeys);
  return [...new Set(previousFeatureKeys)].filter((featureKey) => !next.has(featureKey));
}

export function resetRevokedWorkspaceStores(
  previousFeatureKeys: readonly FeatureKey[],
  nextFeatureKeys: readonly FeatureKey[],
): FeatureKey[] {
  const revoked = revokedWorkspaceFeatureKeys(previousFeatureKeys, nextFeatureKeys);
  for (const featureKey of revoked) WORKSPACE_RESETS[featureKey]();
  return revoked;
}

export function resetAllWorkspaceStores(): void {
  for (const reset of Object.values(WORKSPACE_RESETS)) reset();
}
